export const App = {
  Home: 'Home',
  IngestionResults: 'Import Events',
  Imports: 'Import Events',
  allimports: 'Import Events',
  analytesManage: 'Analytes',
  guidelinesCofactorEntrance: 'Guidelines & Cofactors',
  Guidelines: 'Guidelines',
  Reports: 'Reports',
  DiscreteDataQuery: 'Discrete Data Query',
  ContinuousDataQuery: 'Continuous Data Query',
  Manage: 'Manage',
  Stations: 'Stations',
  ManageStations: 'Manage Stations',
  ManageGuidelines: 'Manage Guidelines',
  System: 'System',
  Administration: 'Administration',
  SearchField: 'Jump to Station',
  Logout: 'Logout',
  Language: 'Language',
  Files: 'Files',
  Analytes: 'Analytes',
  depthHeightDatums: 'Depth / Height Datums',
  DiscreteImportNotifications: 'Discrete Import Notifications',
  FileSchemas: 'File Schemas',
  Flags: 'Flags',
  CurrentUser: 'Current User',
  Top: 'Top',
  accessManageEntrance: 'Tenant Management Dashboard',
  reviewingestionresults: 'Review import events',
  analytesManageError: 'Fix analytes',
  monitoringfeature: 'Monitoring Feature',
  continuousDataOutputTenantManage: 'Manage Continuous Approvals and Data Grades',
  DiscreteSampleFlags: 'Discrete Sample Flags',
  AccessInfo: 'Access Information',
  SwitchTenant: 'Switch Tenant',
  UserProfile: 'User Profile',
}

export const IntroValue = {
  introStart: 'Hello! Welcome to use our system. I will bring you a simple guide. ' + '<br>' + 'ヾ(^▽^*) (click Next)',
  introSwitch: 'This is the switch of Navigation drawer.',
  introSearch: 'This is a versatile Search box.',
  introAdministrator: 'This is the System Administrator portal.',
  introUser: 'This is the Current User portal',
  introStations: 'This is the Stations Navigation.',
  introOperational: 'This is the Operational Navigation.',
  introMessage: 'This is the Message Collection.',
  introGuide: 'You also can click here to watch the guide again.',
  introEnd: 'In the end of the guide, wish you have a good mood.' + '<br>' + ' SEE YOU! ' + '<br>' + '（＾∀＾）ノ (click Done)',
}

export const Button = {
  SystemAdministration: 'System Administration',
  Save: 'Save',
  SaveAs: 'Save As',
  SaveQueryAs: 'Save Query As',
  NewQuery: 'New Query',
  New: 'New',
  Close: 'Close',
  Edit: 'Edit',
  Agree: 'Agree',
  Disagree: 'Disagree',
  Create: 'Create',
  Cancel: 'Cancel',
  UNLINK_STATION: 'UNLINK STATION',
  Add: 'Add',
  REMOVE_STATION: 'REMOVE STATION',
  Yes: 'Yes',
  No: 'No',
  Delete: 'Delete',
  Remove: 'Delete',
  Add_Stations: 'Add Stations',
  Continue: 'Continue',
  Add_a_new_tenant: 'Add a new tenant',
  Manage_Side_Menu: 'Side Menu',
  Manage_Access: 'Stations access',
  Manage_Continuous_Query_Database: 'Continuous Data Access',
  Manage_File_Schemas: 'File Schemas',
  Set_Tenant_and_Project_Names: 'Tenant and Project Names',
  Configure_Reports_Landing_Page: 'Reports access',
  Configure_Station_Dashboard: 'Monitoring Features UI',
  Manage_Depth_Height_Datums: 'Depth/Height Datums',
  Configure_Flags: 'Flags',
  Configure_Manage_CoFactor: 'Manage CoFactor',
  add_link: 'add link',
  unlink: 'unlink',
  Add_tag_for_all: 'Add tag for all',
  add_station: 'add station',
  CANCEL: 'CANCEL',
  Manage_Type: 'Manage Type',
  Add_a_new_Media_Type: 'Add Media Type',
  back: 'back',
  Manage_Category: 'Manage Category',
  Add_a_new_Category: 'Add Category',
  Manage_Tag: 'Manage Tag',
  Add_a_new_Tag: 'Add Tag',
  Confirm: 'Confirm',
  Unlock: 'Unlock',
  Edit_Detail: 'Edit Details',
  Edit_Password: 'Edit Password',
  Delete_User: 'Remove User',
  Add_a_new_user: 'Add user',
  REMOVE_USER: 'REMOVE USER',
  refresh_import_list: 'refresh import list',
  View_Import_Detail: 'View Import Detail',
  ViewAll: 'View All',
  ViewDetails: 'View Details',
  clear: 'clear',
  OK: 'OK',
  More: 'More...',
  View_All_Imported_Data: 'View All Imported Data',
  Next: 'Next',
  Edit_File_Information: 'Edit File Information',
  Edit_Metadata: 'Edit metadata',
  Done: 'Done',
  Download: 'Download',
  DownloadReport: 'Download Report',
  GenerateReport: 'Generate Report',
  Add_Metadata_Field: 'Add Metadata Field',
  Add_Filter: 'Add Filter',
  Clear_Filters: 'Clear Filters',
  Add_a_new_File: 'Add a new File',
  Action: 'Action',
  detail: 'detail',
  Add_Flag: 'Add Flag',
  Expand: 'Expand',
  Collapse: 'Collapse',
  Remove_access: 'Remove access',
  Rollback: 'Rollback',
  Submit: 'Submit',
  Date_Range_Shortcuts: 'Date Range Shortcuts',
  Generate_Graph: 'Generate Graph',
  Previous: 'Previous',
  Go: 'Go',
  View: 'View',
  Edit_Station_Information: 'Edit Location',
  apply: 'apply',
  Generat_Graph_Dashboard: 'Generate Graph Dashboard',
  View_As_Tabular: 'View As Tabular',
  Download_To_Excel: 'Download To Excel',
  DownloadExcelReport: 'Download Excel Report',
  Remove_default_value: 'Remove default value',
  Remove_all: 'Remove all',
  Add_Analyte: 'Add Analyte',
  View_Detail: 'View Detail',
  Set_As_Analyte: 'Promote to new analyte',
  Delete_Alias: 'Remove Alias',
  Add_Alias: 'Add Alias',
  Add_Guideline: 'Add Guideline',
  AddToGuideline: 'Link to guideline standard',
  REMOVE_ALIAS: 'REMOVE ALIAS',
  SET_AS_ANALYTE: 'Promote',
  Statistics: 'Statistics',
  Logs: 'Logs',
  DELETE_ANALYTE: 'Remove ANALYTE',
  DELETE_GUIDELINE: 'Remove GUIDELINE',
  Search: 'Search',
  Manage: 'Manage',
  REMOVETAGFORALL: 'REMOVE TAG FOR ALL',
  AddDatum: 'Add Datum',
  EditDatum: 'Edit Datum',
  DeleteDatum: 'Remove Datum',
  GenerateDefaultLayers: 'Generate Default Layers',
  addMapService: 'add Map Service',
  AddCoFactorAnalyteLink: 'Add cofactor',
  SaveStrategy: 'Save Strategy',
  Check: 'Check',
  AddGuideline: 'Add guideline',
  EditStations: 'Edit stations',
  AddRecipient: 'Add recipient',
  EditReports: 'Edit reports',
  CustomizeReportsReceived: 'Customize reports received',
  Open: 'Open',
  RemoveMissingParameters: 'Remove missing parameters',
  DownloadAnyway: 'Download anyway',
  CreateConfiguration: 'Create Configuration',
  GenerateNewCredentials: 'Generate New Credentials',
  EditService: 'Edit Service',
  RegisterService: 'Register Service',
  ValidateService: 'Validate Service',
  TenantConfigurations: 'Tenant Configurations',
  ServiceCapabilities: 'Service Capabilities',
  ExecutionLogs: 'Execution Logs',
  ClearFilters: 'Clear Filters',
  Clear: 'Clear',
  SelectAll: 'Select all',
  Update: 'Update',
  AddAnalyteLink: 'Add Analyte Link',
  LinkAnalyte: 'Link Analyte',
  UnlinkAnalyte: 'Unlink analyte',
  AddUnit: 'Add Unit',
  AddUnitGroup: 'Add Unit Group',
  ShowasGraph: 'Show as Graph',
  DownloadRawDatatoExcel: 'Download Raw Data to Excel',
  DownloadDailyData: 'Download Daily Data',
  GettingStarted: 'Getting Started',
  AddaNewGuideline: 'Add a new Guideline',
  ViewAllImports: 'View all imports',
  HideDetails: 'Hide details',
  ShowDetails: 'Show details',
  AddDocument: 'Add Document',
  AddDocumentReference: 'Document Reference',
  Merge: 'Merge',
  back_to_all_importlist: 'back to all imports list',
  SetAsResolvedDefaultValue: 'Set as resolved default value',
  Update_Anyway: 'Update Anyway',
  Login: 'Log In',
  Archive: 'Archive',
}



export const RepetitiveTimeSeries = {
  MsgNG: 'There are repetitive timeseries selected in Aquarius NG.',
}

export const RepetitiveTimeSeriesLinkData = {
  MsgNG: 'There are repetitive {msg} in Aquarius NG timeseries link.',
}

export const OtherTabNeedToFill = {
  MsgNG: 'There are required fields in Aquarius NG tabs that need to be filled.',
}

export const SaveUpdateDeleteMsg = {
  SaveMsg: 'Saved import configuration for {msg} successfully',
  UpdateMsg: 'Update import configuration for {msg} successfully',
  DeleteMsg: 'Delete import configuration for {msg} successfully',
}


export const AdministrationAccessManage = {
  deleteSuccessMsg: 'Tenant {msg} deleted successfully',
  addSuccessMsg: 'Tenant {msg} added successfully',
  addTitleMsg: 'Add tenant',
  confirmTitleMsg: 'Are you sure that you want to remove the tenant {msg}?',
  confirmTextMsg: 'Warning: If removed, the tenant information will not be recoverable',
}

export const AdministrationAccessManageEntrance = {
  ProjectInformationDataAccess: 'Project Information & Data Access',
  FlagDatumFileSchema: 'Flag, Datum & File Schema',
  UIConfiguration: 'UI Configuration',
  ContinuousDataOutputManage: 'Continuous Approval and Data Grade',
}

export const AdministrationStationCategoryManage = {
  DiscreteSampleStationCategory: 'Discrete Sample Station Category',
  ContinuousDataStationCategory: 'Continuous Data Station Category',
}

export const AdministrationAddUserDetailDialog = {
  addSuccessMsg: 'User {msg} added successfully',
  addTitleMsg: 'Add user',
}

export const AdministrationContinuousDataStations = {
  addStationLinkMsg: 'There are no available stations to add from',
  saveNewStationLinkSuccessMsg: 'Station {msg} added successfully',
  saveNewStationLinkFailMsg: 'Please select a station to link',
  saveSuccessMsg: 'Continuous station {msg} added successfully',
  unlinkStationSuccessMsg: 'Continuous station {msg} unlinked successfully',
  addTitleMsg: 'Add Continuous Data Station',
  confirmTitleMsg: 'Are you sure that you want to unlink the station {msg}?',
  confirmTextMsg: 'Note: Unlinked stations can be relinked in the future.',
  addTagTitleMsg: 'Add Tag For All',
}

export const AdministrationDiscreteSampleStations = {
  saveEmptyFailMsg: 'Please input station name',
  saveExistFailMsg: 'Station name already exists, please select a different name',
  addNewStationSuccessMsg: 'Station {msg} added successfully',
  deleteStationSuccessMsg: 'Station {msg} deleted successfully',
  addTitleMsg: 'Add Discrete Sample Station',
  confirmTitleMsg: 'Are you sure that you want to remove the station {msg}?',
  confirmTextMsg: 'Warning:  If removed, station information cannot be recovered.',
}

export const AdministrationEditUserDetailDialog = {
  updateSuccessMsg: 'User detail updated successfully',
  editTitleMsg: 'User Detail',
}

export const AdministrationEditUserPasswordDialog = {
  saveSuccessMsg: 'Save successful',
  editTitleMsg: 'User Detail',
}

export const AdministrationMediaTypeManage = {
  addNewTypeSuccessMsg: 'Media type {msg} added successfully',
  updateMediaTypeSuccessMsg: 'Media type {msg} updated successfully',
  addTitleMsg: 'Add Media Type',
  editTitleMsg: 'Edit Media Type',
  confirmTitleMsg: 'Are you sure remove this Media Type?',
  confirmTextMsg: 'This cannot be undone.',
  removeMediaType: 'Remove Media Type',
}

export const AdministrationSideMenuDetail = {
  updateFlagSuccessMsg: 'UserGroupSetting updated successfully!',
}

export const AdministrationStationContinuousCategory = {
  addNewTypeSuccessMsg: 'Station category {msg} added successfully',
  updateStationCategorySuccessMsg: 'Station category {msg} updated successfully',
  addTitleMsg: 'Add Continuous Station Category',
  editTitleMsg: 'Edit Continuous Station Category',
  confirmTitleMsg: 'Are you sure you want to remove station category {msg}?',
  confirmTextMsg: 'Warning: If deleted, the station category will not be recoverable.',
}

export const AdministrationStationDiscreteCategory = {
  addNewTypeSuccessMsg: 'Station category {msg} added successfully',
  updateStationCategorySuccessMsg: 'Station category {msg} updated successfully',
  addTitleMsg: 'Add Category',
  editTitleMsg: 'Edit Station Category',
  confirmTitleMsg: 'Are you sure you want to remove station category {msg}?',
  confirmTextMsg: 'Warning: If deleted, the station category will not be recoverable.',
}

export const AdministrationTimeSeriesTagManage = {
  addTagSuccessMsg: 'Tag {msg} added successfully',
  updateTagSuccessMsg: 'Time Series Tag {msg} updated successfully',
  addTitleMsg: 'Add Tag',
  editTitleMsg: 'Edit Time Series Tag',
}

export const AdministrationUnlockUserDialog = {
  titleMsg: 'User Unlock',
  textMsg: 'Select the unlock mode',
}

export const AdministrationUserManage = {
  deleteUserSuccessMsg: 'Remove successful',
  confirmTitleMsg: 'Are you sure that you want to remove user `{msg}`?',
  confirmTextMsg: 'Once removed, their user information cannot be recovered.',
}

export const ConfirmRemove = {
  confirmTitleMsg: 'Are you sure?',
}

export const ConfirmDeleteImport = {
  confirmTitleMsg: 'Rollback import',
  confirmTextMsg: 'Are you sure you want to rollback this import? Data records created by this import will be removed, and any stations and analytes not referenced by other imports will also be removed.',
}

export const ContinuousApprovalLevelManage = {
  addTenantApprovalLevelFormTitle: 'Add Tenant Approval Level Configuration',
  updateTenantApprovalLevelFormTitle: 'Update Tenant Approval Level Configuration',
  addSystemDefaultApprovalLevelFormTitle: 'Add System Default Approval Level Configuration',
  updateSystemDefaultApprovalLevelFormTitle: 'Update System Default Approval Level Configuration',
  defaultApprovalLevel: 'Default Approval Level',
  continuousDatabaseValue: 'Continuous Database Value',
  outputText: 'Output Text',
  outputDescription: 'Output Description',
  upsertWarning: 'Approval level configuration for database value {msg} already exists. Saving a new configuration with the same database value will cause the existing configuration to be overwritten.',
  addSuccessMessage: 'Added approval level configuration successfully',
  addErrorMessage: 'Sorry, approval level addition failed: {msg}',
  updateSuccessMessage: 'Updated approval level configuration successfully',
  updateErrorMessage: 'Sorry, approval level update failed: {msg}',
  deleteTenantApprovalLevelConfirmation: 'Delete Tenant Approval Level Configuration',
  deleteTenantApprovalLevelTextDefault: 'Are you sure you want to delete tenant default approval level configuration? If no default approval level configuration exist, unrecognized approval levels will be mapped to system default approval value.',
  deleteTenantApprovalLevelTextNonDefault: 'Are you sure you want to delete tenant approval level configuration mapped to database value {msg}? Once deleted, the confirmation will not be recoverable.',
  deleteSystemDefaultApprovalLevelConfirmation: 'Delete System Default Approval Level Configuration',
  deleteSystemDefaultApprovalLevelTextDefault: 'Are you sure you want to delete default approval level configuration? If no default approval level configuration exist, unrecognized approval levels will be mapped to Unprocessed',
  deleteSystemDefaultApprovalLevelTextNonDefault: 'Are you sure you want to delete system default approval level configuration mapped to database value {msg}? Once deleted, the confirmation will not be recoverable.',
  deleteSuccessMessage: 'Approval level configuration deleted successfully',
  deleteErrorMessage: 'Sorry, approval level deletion failed: {msg}',
  default: 'Default',
}

export const ContinuousDataGradesManage = {
  menuTextYes: 'Filtered grade values will be filtered out and will not be included in the Aquarius query results.',
  menuTextNo: 'Non-filtered grade values will be included in the graph and report output once they have output configuration setup.',
  unableUpdate: 'Unable to update Data Grade Value',
  unableUpdateMsg: 'The selected data grade value is currently associated with one output configuration, hence it cannot be updated to be filtered out. Please first dissociate the data grade value from all output configurations, then update the data grade value again.',
  errorMessage: 'Error Message',
  unableDelete: 'Unable to delete Data Grade Value',
  unableDeleteMsg: 'The selected data grade value is currently associated with one output configuration, hence it cannot be deleted. Please first dissociate the data grade value from all output configurations, then try deleting again.',
  saveSuccessMsg: 'Save successfully.',
  deleteSuccessMsg: 'Delete successfully.',
  valueExists: 'The input value already exists, please check carefully.',
  couldNotBeNull: 'Could not be null, please check again.',
  codeExists: 'The input Code already exists, please check carefully.',
  shouldFilterOutCouldNotBeYes: 'The selected data has been bound to the Configuration."Should Filter out" could not be "yes".',
}

export const ContinuousDataQualifiersManage = {
  menuTextYes: 'Filtered qualifier values will be filtered out and will not be included in the Aquarius query results.',
  menuTextNo: 'Non-filtered qualifier values will be included in the graph and report output once they have output configuration setup.',
  unableUpdate: 'Unable to update Data Qualifier Value',
  unableUpdateMsg: 'The selected data qualifier value is currently associated with one output configuration, hence it cannot be updated to be filtered out. Please first dissociate the data qualifier value from all output configurations, then update the data qualifier value again.',
  errorMessage: 'Error Message',
  unableDelete: 'Unable to delete Data Qualifier Value',
  unableDeleteMsg: 'The selected data qualifier value is currently associated with one output configuration, hence it cannot be deleted. Please first dissociate the data qualifier value from all output configurations, then try deleting again.',
  saveSuccessMsg: 'Save successfully.',
  deleteSuccessMsg: 'Delete successfully.',
  valueExists: 'The input value already exists, please check carefully.',
  couldNotBeNull: 'Could not be null, please check again.',
  codeExists: 'The input Code already exists, please check carefully.',
  shouldFilterOutCouldNotBeYes: 'The selected data has been bound to the Configuration."Should Filter out" could not be "yes".',
}

export const DataSetAddFileDialog = {
  addTitleMsg: 'Add File',
  uploadingTipsMsg: 'File upload in progress, please do not refresh or close the browser.',
  uploadedTipsMsg: 'File upload completed, please click "Next" to enter the metadata.',
  fileSizeLimitWarningMsg: 'The maximum file size is 10MB. Files larger than 10MB cannot be uploaded.',
  fileSizeExceededMsg: 'The selected file exceeds the 10MB limit. Please choose a smaller file.',
  exitDialogTitleMsg: 'Upload Cancel',
  exitDialogUploadingTipsMsg: 'File upload would be cancelled if window is closed. Are you sure?',
  exitDialogUploadCompletedTipsMsg: 'The uploaded file would be removed if close the window. Are  you sure to continue?',
}

export const DatasetMetadataSchemaManage = {
  addTitleMsg: 'Add File Schema',
}

export const FlagsManage = {
  addSuccessMsg: 'Flag {msg} added successfully',
  addFailMsg: 'Cannot be null,please enter fully',
  updateSuccessMsg: 'Flag {msg} updated successfully',
  updateFailMsg: 'Cannot be null,please enter fully',
  deleteSuccessMsg: 'Flag {msg} deleted successfully',
  addTitleMsg: 'Add Flag',
  addTextMsg: 'Warning: results that are assigned this flag will be hidden in all reports, graphs and queries.',
  updateTitleMsg: 'Update flag',
  updateTextMsg: 'Warning: results that are assigned this flag will be hidden in all reports, graphs and queries.',
  confirmTitleMsg: 'Are you sure you want to remove the flag?',
  confirmTextMsg: 'Please confirm flag deletion. If you proceed, all values with this flag will be updated to remove this flag.',
}

export const GuidelinesDetailForm = {
  updateSuccessMsg: 'Guideline {msg} updated successfully',
  addSuccessMsg: 'Guideline {msg} added successfully',
}

export const GuidelinesDetailStandards = {
  saveFailMsg: 'Please complete the form!',
  updateSuccessMsg: 'Guideline standard for {msg1} in {msg2} updated successfully',
  deleteSuccessMsg: 'Guideline standard for {msg1} in {msg2} deleted successfully',
  titleMsg: '{msg}',
  confirmTitleMsg: 'Are you sure sure you want to unlink {analyteName}?',
  confirmTextMsg: 'Once removed, this link cannot be recovered.',
  standardValueSaveConfirmTitleMsg: 'Cofactor {name} does not contain unit information',
  standardValueSaveConfirmTextMsg: 'Cofactor {name} does not contain unit information and will be set to "N/A" automatically. Incomplete unit information may cause issues in guideline calculation. Are you sure you want to save?',
  standardValueErrorFormattingMsg: 'There’s an error in the formatting of the guideline value, please refer to the guideline value tips (click icon value beside values input) for examples.',
  addTitle: 'Add Link Analyte',
  deleteTitle: 'Remove Link Analyte',
  ammonialookuptableTooltip: 'The guideline value for the {msg} cannot be edited manually, please contact Hatfield if you require assistance.',
  differentTitle: 'Unit update will affect existing analyte-guideline {link}',
  differentMsg: 'The following guideline update action will affect existing analyte-guideline links for the following {tenant}: {msg}. Are you sure you would like to update the guideline? If so, you must update the analyte-guideline links of the mentioned {tenant}.',
}

export const GuidelinesDetailTenant = {
  addTenantFailMsg: 'No more tenants to add to this guideline.',
  addGuidelineTenantFailMsg: 'This Tenant Name is empty, please choose the station name!',
  addGuidelineTenantSuccessMsg: 'Guideline permissions added successfully',
  updateGuidelineTenantSuccessMsg: 'Guideline permissions updated successfully',
  deleteGuidelineTenantSuccessMsg: 'Guideline permissions deleted successfully',
  addTitleMsg: 'Add guideline',
  addTenantTitleMsg: 'Add tenant',
  confirmTitleMsg: 'Remove access {msg1} for {msg2}?',
  confirmTextMsg: 'The tenant will no longer see this guideline. You can add them back at any time.',
}

export const LoadingScreen = {
  titleMsg: 'Loading',
}

export const StationDetailAddMetadata = {
  addFieldFailMsg: '"Field" cannot be empty, Please input content.',
  addFieldTypeFailMsg: '"FieldType" cannot be empty, Please input content.',
  addFieldValueFailMsg: '"FieldValue" cannot be empty, Please input content.',
  addOrdinalFailMsg: '"Ordinal" cannot be empty, Please input content.',
  addValueFailMsg: '"value" is not the "Number" type, Please input number or change "FieldType".',
  addSuccessMsg: 'Station information saved successfully',
  addTitleMsg: 'Add Station Information',
}

export const StationDetailModify = {
  updateSuccessMsg: 'Station information for field {msg} updated successfully',
  deleteSuccessMsg: 'Station information for field {msg} deleted successfully',
  editTitleMsg: 'Edit Station Information',
  confirmTitleMsg: 'Are you sure you want to remove this station metadata?',
}

export const StationDetailPhotos = {
  noPhotos: 'There are no photos yet. You can add photos through our FTP Server.',
}

export const StationDetailSampleActivity = {
  updateSuccessMsg: 'Station information for field {msg} updated successfully',
  alertMsg: 'This station does not have any sample activities',
  titleMsg: 'Sample Activity Detail',
  subheadFirstMsg: 'Documents',
  subheadSecondMsg: 'Imports',
  tipsMsg: '*indicates required field',
}

export const StationEditContinuousCategory = {
  saveSuccessMsg: 'Save successful',
  saveFailMsg: 'The station is already of type {msg}',
  editTitleMsg: 'Edit Station Category',
}

export const StationEditNameDialog = {
  saveSuccessMsg: 'Station name updated successfully',
  saveEmptyFailMsg: 'Name is required',
  saveSameFailMsg: 'Station name {msg} already exists. Please select a different name',
  editTitleMsg: 'Edit Station Name',
}

export const StationEditStationCategory = {
  saveSuccessMsg: 'Save successful',
  saveFailMsg: 'The station is already of type {msg}',
  editTitleMsg: 'Edit Station Category',
}

export const StationManageMergeDialog = {
  titleAMsg: 'Merge Station as Alias',
  titleBMsg: 'Add QaQc Replicate Alias Station',
  titleCMsg: 'Add Depth/Height Alias Station',
  confirmTitleAMsg: 'Are you sure you want to add {msg1} as an Alias of {msg2}?',
  confirmTitleBMsg: 'Are you sure you want to add {msg1} as a QaQc Replicate Alias of {msg2}?',
}

export const StationManageSplitDialog = {
  titleMsg: 'Remove alias {msg1} from station {msg2}?',
  textMsg: 'Alias {msg} will be created as a separate station with no QaQc status.',
  alertMsg: 'Please do not close your browser until the alias is removed',
}

export const StationSideMenu = {
  ContinuousDataStations: 'Continuous Data Stations',
  DiscreteSampleStations: 'Discrete Sample Stations',
  VegetativePlots: 'Vegetative Plots',
  AllStations: 'All Stations',
  Groupstations: 'Group stations:',
  SurveyLocations: "Survey Locations",
}

export const StationSelectDialog = {
  titleMsg: 'Select Stations',
}

export const StationWaterQualityGraph = {
  titleMsg: 'Select no more than 5 analytes for optimal performance',
  textMsg: 'Are you sure to continue?',
}

export const StationWaterQualityTabular = {
  addFailMsg: 'No measurement selected!',
  titleAMsg: 'Data from {msg1} to {msg2}',
  alertMsg: 'Sorry, there is currently no analyte data available for this station. Please update the selected analyte(s), time range and try again.{msg}',
  subheadMsg: 'Add flags to selected measurements:',
  titleBMsg: 'Flags:',
  textMsg: 'Some values have been excluded from this report due to the following flags:',
  titleCMsg: 'Options:',
}

export const WaterQualityReports = {
  tipsMsg: 'No measurement selected!',
}

export const WaterQualityReportErrorModal = {
  titleMsg: 'Error occurred during report export',
  descriptionMsg: 'Report data can still be exported by clicking Download, but the produced report will not include any of the below data points',
  customDescriptionMsg: 'See error {msg} below for more detail. Report data can still be exported by clicking Download, but the produced report will not include the following ',
  errorMessage: 'Error {msg}',
  unexpectedErrorMsg: 'Generate report fails due to unexpected error{message}. You can still try to download the report by clicking the "Download anyway" button. If the issue persists, please contact the system administrator.',
  downloadAnyway: 'Download Anyway',
}

export const WaterQualityGraphErrorModal = {
  titleMsg: 'Error occurred during graph generation',
  analyteUnitMismatchMsg: 'See error {messagePart} below for more detail. Please contact tenant administrator to update the following guideline {setttingPart} then try generating graph again.',
  labResultUnitMismatchMsg: 'See error {messagePart} below for more detail. Please contact tenant administrator to update or flag the following data {pointPart} then try generating graph again.',
  BothMsg: 'See error messages below for more detail. Please contact tenant administrator to update the following guideline {setttingPart} and update or flag the following data {pointPart} then try generating graph again.',
  errorMessage: 'Error {msg}',
}

export const WaterQualityAnalyteLabResultUnitMismatchErrorModal = {
  date: 'Date',
  site: 'Site',
  analyte: 'Analyte',
  cocCode: 'COC Code',
  labSampleId: 'Lab Sample Id',
  databaseSampleId: 'Database Sample Id',
  message: 'Message',
}

export const WaterQualityAnalyteGuidelineUnitMismatchErrorModal = {
  analyte: 'Analyte',
  analyteUnitGroup: 'Analyte Unit Group',
  guidelineShortName: 'Guideline Short Name',
  guidelineStandard: 'Guideline Standard',
  guidelineStandardUnit: 'Guideline Standard Unit',
  message: 'Message',
}

export const AnalyteManage = {
  titleMsg: 'Are you sure that you want to remove the analyte {msg}?',
  deleteMsg: 'Warning: If removed, the analyte information will not be recoverable.',
  repeatMsg: 'This analyte name already exists. Please select a new analyte name.',
  successSaveMsg: '{msg} saved successfully',
  nullMsg: 'The Analyte Name cannot be empty. Please select an analyte name.',
  successDeleteMsg: 'Analyte removed successfully',
  cannotDeleteMsg: 'This analyte could not be deleted because it is linked to existing lab results. If you want to remove it, please remove all related lab results and try again.',

  analyteWithoutAliasCheckingMsg: '<strong>Analytes without an alias:</strong>',
  analyteWithoutDefaultUnitGroupCheckingMsg: '<strong>Analytes without an applicable unit group:</strong>',
  analyteWithoutDefaultUnitCheckingMsg: '<strong>Analytes without a default unit:</strong>',
  analyteUnitNotMatchUnitGroupCheckingMsg: '<strong>Analytes where the unit does not match their applicable unit group:</strong>',
  analyteGuidelineLinkHaveMismatchedUnitGroupCheckingMsg: '<strong>The following Analyte-Guideline links have mismatched unit groups. Guideline calculation will fail unless you fix these links:</strong>'
}
export const AnalyteManageError = {
  analyteWithoutAliasDescription: 'Analyte has no alias.',
  analyteWithoutDefaultUnitGroupDescription: 'Analyte has no applicable unit group.',
  analyteWithoutDefaultUnitDescription: 'Analyte has no default unit.',
  analyteUnitNotMatchUnitGroupDescription: 'Analyte\'s default unit is not in an applicable unit group.',
  analyteGuidelineLinkHaveMismatchedUnitGroupDescription: 'Analyte - guideline unit group mismatch with: {guidelineShortName}_{standardAnalyteName}.'
}

export const AnalyteDetailInformation = {
  titleMsg1: 'Demote to alias',
  alertMsg: 'The current analyte and its alisses will become aliases of the target analyte.',
  successSaveMsg: 'Alias added successfully',
  successSaveMsg1: 'Analyte saved successfully',
  nullMsg: 'The analyte name cannot be empty. Please enter an analyte name.',
  nullMsg1: 'The method cannot be empty. Please enter a method name.',
  nullLinkMsg: 'The link analyte cannot be empty. Please select an analyte.',
  differentTitle: 'Unit update will affect existing analyte-guideline {link}',
  differentMsg: 'The following analyte update action will affect existing analyte-guideline {link} for the following {guideline} {msg}. Are you sure you would like to update the analyte? If so, you must update the analyte-guideline {link} of the mentioned {guideline}.',
  affectAnalyteCofactorTitle: 'Unit update will affect existing analyte-cofactor mapping',
  affectAnalyteCofactorMsg: 'The following analyte update action will affect existing analyte-cofactor {link} for the following {cofactor} {msg}. This will cause errors to occur during guideline calculation. Are you sure you would like to update the analyte? If so, you must update the analyte-cofactor {link} of the mentioned {cofactor}.',
}

export const AnalyteAliaManagement = {
  addTitleMsg: 'Add Analyte Alias',
  editTitleMsg: 'Edit Aliases',
  deleteTitleMsg: 'Are you sure that you want to remove the alias {msg}?',
  deleteMsg: 'Warning: If removed, the alias information will not be recoverable.',
  setTitleMsg: 'Are you sure that you want to promote the alias {analyteName} to a new analyte?',
  repeatMsg: 'This alias name and method combination already exists for analyte {msg}. Please update the values and try again.',
  successSaveMsg: 'Alias saved successfull.',
  nullMsg: 'Alias name and method can not be empty, please input the values.',
  successDeleteMsg: 'Alias removed successfully.',
}

export const AnalyteGuidelinesManagement = {
  tableName: 'Referenced guideline standards',
  tableSearch: 'Search Guidelines List:',
  tableHeader1: 'Guideline',
  tableHeader2: 'Standard',
  tableHeader3: 'Value',
  tableHeader5: 'Unit',
  tableHeader6: 'Reference',
  tableHeader7: 'Action',
  dialogInput1: 'Guideline',
  dialogInput2: 'Standard',
  dialogInput3: 'Analyte',

  addTitleMsg: 'Link to guideline standard',
  deleteTitleMsg: 'Are you sure you want to unlink the analyte {msg} from the guideline standard?',
  deleteMsg: 'Warning: If removed, the guideline will not be recoverable',
  successSaveMsg: 'Analyte linked successfully.',
  successDeleteMsg: 'Analyte unlinked successfully.',
  nullMsg: 'The guideline and analyte cannot be empty. Please enter guideline and analyte.',
  errorMsg: 'Sorry, an unknown error occurred. Please try again, and contact Hatfield if the issue persists.',
  singleMismatchedUnitGroup: 'The following Analyte-Guideline link has mismatched unit groups. Guideline calculation will fail unless you fix this link:',
  multipleMismatchedUnitGroups: 'The following Analyte-Guideline links have mismatched unit groups. Guideline calculation will fail unless you fix these links:',
}
export const GuidelineManagement = {
  deleteTitleMsg: 'Are you sure you want to remove the guideline {longName} ({shortName})?',
  deleteMsg: 'Warning: If removed, the guideline and relavant data will not be recoverable.',
  successDeleteMsg: 'Guideline removed successfully.',
}

export const MessageCollection = {
  titleMsg: 'All Messages',
  NoMsg: 'No message now.',
  InformationMsg: 'Information:',
  TipsMsg: 'Tips:',
}

export const StationDetailDownload = {
  alertDateSeries: 'Select a time series.',
  alertDateRange: 'Select a date range.',
  alertStatisticalValue: 'Select a daily statistic for all time series.',
  alertDailyTotal: 'Daily Total is only available for a non-cumulative rainfall, precipitation and evapotranspiration time series.',
}

export const MonitoringFeatureAlias = {
  aliasCanContainDataMsg: 'Imported data can be assigned to aliases.',
}

export const UnitDetailManage = {
  addTitle: 'Add Unit',
  editTitle: 'Edit Unit: {msg}',
  deleteMsg: 'If removed, data will not be recoverable.',
}

export const UnitGroupDetail = {
  addTitle: 'Add Unit To Group',
  editTitle: 'Unit Conversion Information',
  deleteTitle: 'Remove Unit From Group',
  deleteMsg: 'If removed, data will not be recoverable.',
}

export const GuidelineCoFactor = {
  addTitle: 'Add cofactor',
  editTitle: 'Edit CoFactor Analyte Link',
  deleteTitle: 'Remove cofactor',
  deleteMsg: 'Are you sure? The removed cofactor cannot be recovered.',
  UpdateCofactorAnalyteLinkSuccessMsg: 'Cofactor {cofactorName} saved successfully.',
  DeleteCofactorAnalyteLinkSuccessMsg: 'Cofactor {cofactorName} deleted successfully.',
  ConfirmMsg: 'CoFactors {misMatchCofactorNames} are mapped to the same analyte but have different default values. This can cause problems during guideline calculation.',
  CoFactorAnalyteMismatchedUnitGroupMsg: 'The applicable unit group of analyte {analyte} is {analyteUnitGroup}, which is mismatched with cofactor {cofactor}\'s unit group {cofactorUnitGroup}.'
}

export const GuidelineAnalyteDefaultValues = {
  hasConflictingMsg: 'Conflicting default values found in cofactors linked to this analyte, cofactor calculations may not function properly unless conflicts are resolved.',
}

export const CofactorManage = {
  cofactorWithoutLinkMsg: 'The following CoFactor is not assigned to an analyte: ',
  cofactorsWithoutLinkMsg: 'The following CoFactors are not assigned to an analyte: ',
  cofactorWithoutLinkLinkMsg: 'The system cannot calculate guideline values without a link between analytes and cofactors. Please assign analyte links in the “CoFactor List” table below.',

  cofactorWithoutDefaultValueMsg: 'The following CoFactor does not have a default value for the current guideline calculation strategy: ',
  cofactorsWithoutDefaultValueMsg: 'The following CoFactors do not have a default value for the current guideline calculation strategy: ',
  cofactorWithoutDefaultValueLinkMsg: 'In the scenario where data cannot be found for a given CoFactor during a guideline calculation, the default value for the CoFactor is used. Please configure default values in the “CoFactor Default” Values table below.',

  cofactorWithDifferentDefaultValuesMsg: 'The following CoFactors are linked to same analyte but they have different default values for the current guideline calculation strategy: ',
  cofactorsWithDifferentDefaultValuesMsg: 'The following CoFactors are linked to same analyte but they have different default values for the current guideline calculation strategy: ',
  cofactorWithDifferentDefaultValuesLinkMsg: 'In the scenario where data cannot be found for a given CoFactor during a guideline calculation, the default value for the CoFactor is used. Please configure default values in the “CoFactor Default” Values table below.',

  coFactorAnalyteWithMismatchedUnitGroupMsg: 'The following CoFactor-Analyte {link} have mismatched unit {group}.',
}

export const TenantGuidelinesDetailStandards = {
  tooltipMsg: 'Analyte and linked guideline are not in the same applicable unit group. Please edit the unit group of the analyte, or unlink the analyte from the guideline.',
}

const default_translations = { 
  'Sample flags': 'Sample flags',
  'View recipients': 'View Recipients',
  'Download': 'Download',
  'Generate again': 'Generate again',
}

export default default_translations